import { Module } from "vuex";
import { FirebaseApp, initializeApp } from "firebase/app";
import { Analytics, getAnalytics, logEvent } from "firebase/analytics";
import { RootState } from "..";

export interface FirebaseState extends RootState {
    firebaseApp: FirebaseApp;
    firebaseAnalytics: Analytics;
}

export default <Module<FirebaseState, RootState>>{
    namespaced: true,
    state: {
        firebaseApp: {} as FirebaseApp,
        firebaseAnalytics: {} as Analytics
    },

    mutations: {
       INIT_FIREBASE(state, firebaseConfig: any) {
            try{
                state.firebaseApp = initializeApp(firebaseConfig);
                state.firebaseAnalytics = getAnalytics(state.firebaseApp);
            }
            catch {
                console.error("Failed to load firebase.")
            }
       },

       LOG_FIREBASE_SCREEN(state, screenName: string) {
            try {
                logEvent(state.firebaseAnalytics, 'screen_view', {
                    firebase_screen: 'WSA/' + screenName,
                    firebase_screen_class: ""
                });
            }
            catch{
                console.error("Failed to load firebase.")
            }
       },
       LOG_FIREBASE_EVENT(state, event: string, params?: any) {
            try{
                logEvent(state.firebaseAnalytics, event, params? params : null);
            }
            catch{
                console.error("Failed to load firebase.")
            }
       },
    },

}